/**
 * Get the path to the leaf widget in a tree of nested widgets.
 *
 * Example:
 * Widget data look like the following object:
 * {
 *   widget1: {
 *     metadata: {
 *       widgets: {
 *         widget2: {
 *           metadata: {
 *             widgets: {
 *               widget3: {
 *                 value: 'val'
 *             }
 *           }
 *         }
 *       }
 *     }
 *   }
 * }
 * If 'widget1/widget2/widget3' is provided as input, the function will return
 * ['widget1', 'metadata', 'widgets', 'widget2', 'metadata', 'widgets', 'widget1/widget2/widget3',
 *  'value']
 *
 * @param {namesStr} A string of '/' separated widgets
 * @return {Object[]} The array of strings to the last node
 */
export function toArray(namesStr) {
  const namesArr = namesStr.split('/');
  return namesArr.reduce((prev, curr, index) => {
    const isLast = index === namesArr.length - 1;
    return isLast
      ? prev.concat([namesStr, 'value'])
      : prev.concat([curr, 'metadata', 'widgets']);
  }, []);
}
